<template>
    <div class="notfound-page">
        <div class="container">
            <div class="section-title">
                <h1>Данная страница не найдена</h1>
            </div>
            <div class="info-container">
                <div class="col-left">
                    <div class="in">
                        <h3>Ошибка №</h3>
                        <strong>404</strong>
                    </div>
                </div>
                <div class="col-right">
                    <div class="col-desc">
                        <p>
                            Страница, которую вы открываете не найдена или уже не существует.
                        </p>
                        <p>
                            Вы можете вернуться на главную страницу сайта. 
                        </p>
                    </div>
                    <router-link :to="{name: 'home'}" class="default-red-link">НА ГЛАВНУЮ СТРАНИЦУ</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store.js'
    import {mapGetters} from 'vuex'
    export default {
        name: 'page--404',
        components: {
        },
        data () {
            return {
                titlePage: 'Страница не найдена',
            }
        },
        methods: {
        },
        computed: mapGetters({
            pageSetup: 'loadHowToBy',
            currentCityArr: 'loadCurrentCityArr',
            titleSite: 'loadSiteTitle',
        }),
        beforeRouteEnter (to, from, next) {
            next(vm =>{
                    vm.$store.commit('removePageLoaderImg')
                    vm.$parent.$refs.topProgress.done()
                }
            );
            // if (store.state.projectItems != null) {
            //     next(vm => {
            //       vm.$store.commit('removePageLoaderImg');
            //       vm.$parent.$refs.topProgress.done()
            //     });
            // } else {
            //     store.dispatch('getBuiltItems').then((response) => {
            //         // console.log(resp, 'HOME')
            //         if (response) {
            //             next(vm => {
            //               vm.$store.commit('removePageLoaderImg');
            //               vm.$parent.$refs.topProgress.done()
            //             });
            //         } else {
            //             next(false, vm => vm.$parent.$refs.topProgress.fail());
            //         }
            //     });
            // }
        },
        beforeCreate() {
            document.body.dataset.page = '404--page';
        },
        created () {
            document.title = this.titlePage + ' - ' + this.titleSite;
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/404/404-page.scss';
    @import '@/styles/components/404/404-page-respond.scss';
</style>